module.exports = __webpack_public_path__ + "static/media/thumb.81b520f0.jpg";